import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "../hooks/useHandleError";
import { BASE_URL } from "../api";
import { getAuthToken } from "../token";

export const UserContext = createContext();

export function UserProvider({ children }) {
    const handleError = useHandleError();
    const [userName, setUserName] = useState("");
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const mid = sessionStorage.getItem("mid");
    const fetchUserData = useCallback(async () => {
        const currentMid = sessionStorage.getItem("mid");
        const currentToken = getAuthToken();
        if (!currentToken || !currentMid) return;
        setLoading(true);

        try {
            const savedName = Cookies.get("username");
            if (savedName) setUserName(savedName);

            const savedData = Cookies.get("userdata");
            if (savedData) {
                try {
                    setUserData(JSON.parse(savedData));
                } catch (e) { }
            }

            const res = await axios.get(`${BASE_URL}/account/get_user_data`, { headers: getApiHeaders() });

            if (res.data.code === 200) {
                const data = res.data.data;
                setUserName(data.fname);
                setUserData(data);
                Cookies.set("userdata", JSON.stringify(data), { expires: 7 });
                Cookies.set("username", data.fname, { expires: 7 });
                if (data?.loginid) sessionStorage.setItem("loginid", data.loginid);
            };

        } catch (err) {
            handleError(err);
        } finally {
            setLoading(false);
        };
    }, [handleError]);

    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <UserContext.Provider value={{ userName, setUserName, userData, loading, fetchUserData }}>
            {children}
        </UserContext.Provider>
    );
}

export const useUser = () => useContext(UserContext);